<app-lfsa-card [innTemplate]="enviarTemplateDatos" [titulo]="'Recaudación y Sustentos'"></app-lfsa-card>
<ng-template #enviarTemplateDatos>
  <!-- <div class="nav-tabs-custom"> -->
  <ul class="nav nav-tabs" id="myTab" role="tablist">
    <li class="nav-item" role="presentation">
      <button class="nav-link active" id="Opcion1-tab" data-bs-toggle="tab" data-bs-target="#Opcion1" type="button"
        role="tab" aria-controls="Opcion1" aria-selected="true">
        <h5><strong>Opcion1</strong></h5>
      </button>
    </li>
    <li class="nav-item" role="presentation">
      <button class="nav-link " id="Opcion2-tab" data-bs-toggle="tab" data-bs-target="#Opcion2" type="button" role="tab"
        aria-controls="Opcion2" aria-selected="false">
        <h5><strong>Opcion2</strong></h5>
      </button>
    </li>
    <li class="nav-item" role="presentation">
      <button class="nav-link " id="Opcion3-tab" data-bs-toggle="tab" data-bs-target="#Opcion3" type="button" role="tab"
        aria-controls="Opcion3" aria-selected="false">
        <h5><strong>Opcion3</strong></h5>
      </button>
    </li>
  </ul>
  <!-- </div> -->

  <div class="tab-content" id="myTabContent">

    <!-- <div role="tabpanel" class="active tab-pane" id="Opcion1" aria-labelledby="Opcion1"> -->
    <div class="tab-pane fade show active" id="Opcion1" role="tabpanel" aria-labelledby="Opcion1-tab">
      <app-lfsa-card [innTemplate]="Opcion1" [titulo]="'Opcion1'" [efecto]="false" [colapseName]="'tabOpcion1'"
        [banderaColapse]='true'></app-lfsa-card>
      <ng-template #Opcion1>
        <form [formGroup]="formulario" novalidate class="form-group">
          <div class="row">
            <div [class]="resposiveFull + 'col-xl-2'">
              <app-lfsa-combo-box-mult [mostrarImg]="false" [rutaImagen]="periodoIcon"
                (enviarOjeto)="obtenerAnios($event)" [placeholder]="'Año'" [opcion]="'valor'" [idOpcion]="'clave'"
                [comboBox]="cmbAnio" [label]="'Año'" [id]="'anio'">
              </app-lfsa-combo-box-mult>
            </div>
            <div [class]="resposiveFull + 'col-xl-2'">
              <app-lfsa-combo-box-mult [mostrarImg]="false" [rutaImagen]="periodoIcon"
                (enviarOjeto)="obtenerPeriodo($event)" [placeholder]="'Periodo'" [opcion]="'valor'" [idOpcion]="'clave'"
                [comboBox]="cmbPeriodo" [label]="'Periodo'" [id]="'periodo'">
              </app-lfsa-combo-box-mult>
            </div>
            <div [class]="resposiveFull + 'col-xl-2'">
              <app-lfsa-combo-box-mult [mostrarImg]="false" [rutaImagen]="agenciaIcon"
                (enviarOjeto)="obtenerAngencias($event)" [placeholder]="'Agencias'" [opcion]="'cadena'"
                [idOpcion]="'idOficinaVenta'" [comboBox]="cmbOfiVentas" [label]="'Agencias'" [id]="'agencias'">
              </app-lfsa-combo-box-mult>
            </div>
            <div [class]="resposiveFull + 'col-xl-2'">
              <app-lfsa-input [mostrarImg]="false" [rutaImagen]="clienteIcon" [control]="formulario.get('cliente')"
                [placeholder]="'Codigo Cliente'" formControlName="cliente" [label]="'Cliente'" [type]="'number'"
                [id]="'cliente'">
              </app-lfsa-input>
            </div>
            <div [class]="resposiveFull + 'col-xl-2'">
              <app-lfsa-combo-box-mult [mostrarImg]="false" [rutaImagen]="empresaIcon"
                (enviarOjeto)="obtenerEmpresas($event)" [placeholder]="'Empresas'" [opcion]="'dscaEmpresa'"
                [idOpcion]="'idEmpresa'" [comboBox]="cmbEmpresas" [label]="'Empresas'" [id]="'empresas'">
              </app-lfsa-combo-box-mult>
            </div>
            <div [class]="resposiveFull + 'col-xl-2'">
              <label>&nbsp;</label><br>
              <button class="btn btn-success btn-block" (click)="buscarDocumentos()">
                <i class="fa fa-search"></i>
                Buscar</button>
            </div>
          </div>
        </form>
      </ng-template>
      <!-- <br> -->
    </div>


    <!-- <div role="tabpanel" class="tab-pane fade" id="Opcion2" aria-labelledby="Opcion2"> -->
    <div class="tab-pane fade" id="Opcion2" role="tabpanel" aria-labelledby="Opcion2-tab">
      <app-lfsa-card [innTemplate]="Opcion2" [titulo]="'Opcion2'" [efecto]="false" [colapseName]="'tabOpcion2'"
        [banderaColapse]='true'></app-lfsa-card>
      <ng-template #Opcion2>
        <form [formGroup]="formulario" novalidate class="form-group">
          <div class="row">
            <div [class]="resposiveFull + 'col-xl-2'">
              <app-lfsa-input [control]="formulario.get('numFacturaFabril')" [placeholder]="'Num. Factura Fabril:'"
                formControlName="numFacturaFabril" [label]="'Num. Factura Fabril:'" [type]="'number'"
                [id]="'numFacturaFabril'">
              </app-lfsa-input>
            </div>
            <div [class]="resposiveFull + 'col-xl-2'">
              <label>&nbsp;</label><br>
              <button class="btn btn-success btn-block" (click)="buscarDocumentosNumFac()">
                <i class="fa fa-search"></i>
                Consultar Datos</button>
            </div>

          </div>
        </form>
      </ng-template>
      <!-- <br> -->
    </div>

    <!-- <div role="tabpanel" class="tab-pane fade" id="Opcion3" aria-labelledby="Opcion3-tab"> -->
    <div class="tab-pane fade" id="Opcion3" role="tabpanel" aria-labelledby="Opcion3-tab">
      <app-lfsa-card [innTemplate]="Opcion3" [titulo]="'Opcion3'" [efecto]="false" [colapseName]="'tabOpcion3'"
        [banderaColapse]='true'></app-lfsa-card>
      <ng-template #Opcion3>
        <form [formGroup]="formulario" novalidate class="form-group">
          <div class="row">
            <div [class]="resposiveFull + 'col-xl-2'">
              <app-lfsa-input [control]="formulario.get('numCobroFabril')" [placeholder]="'Num. Cobro Fabril:'"
                formControlName="numCobroFabril" [label]="'Num. Cobro Fabril:'" [type]="'number'"
                [id]="'numCobroFabril'">
              </app-lfsa-input>
            </div>
            <div [class]="resposiveFull + 'col-xl-2'">
              <label>&nbsp;</label><br>
              <button class="btn btn-success btn-block" (click)="buscarDocumentosNumCob()">
                <i class="fa fa-search"></i>
                Consultar Datos
              </button>
            </div>
          </div>
        </form>
      </ng-template>
      <!-- <br> -->
    </div>

  </div>
  <hr>

  <app-lfsa-card [innTemplate]="enviarTemplateGrid" [titulo]="'Documentos'" [efecto]="false" [colapseName]="'tabGrid'"
    [banderaColapse]='true'></app-lfsa-card>
  <ng-template #enviarTemplateGrid>
    <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
    <div *ngIf="!loading">
      <div class="alert alert-danger animated fadeInRight" role="alert" *ngIf="listaVacia">
        No existen datos para la lista de Documentos.
      </div>
      <ag-grid-angular *ngIf="!listaVacia" #agGrid class=" {{sustentosModulo.agGrid.class}}" #agGrid1
        [ngStyle]="sustentosModulo.agGrid.style" id="{{sustentosModulo.agGrid.id}}" [floatingFilter]="true"
        [frameworkComponents]="frameworkComponents " [columnDefs]="columnDefs" [rowSelection]="rowSelection"
        [rowData]="rowData" (gridReady)="onGridReady($event)" [pagination]="true"
        [paginationPageSize]="sustentosModulo.agGrid.paginacion" (cellClicked)="rowClickData($event)">
      </ag-grid-angular>
    </div>
  </ng-template>
  <hr>

  <app-lfsa-loading-v2 *ngIf="loaderTabs"></app-lfsa-loading-v2>
  <div *ngIf="!loaderTabs">
    <div class="nav-tabs-custom">
      <ul class="nav nav-tabs" role="tablist">
        <li class="nav-item">
          <!-- <a class="nav-link  active" href="#infGeneral" data-toggle="tab">
            <h3><strong>Inf.General</strong></h3>
          </a> -->
          <button class="nav-link active" id="infGeneral-tab" data-bs-toggle="tab" data-bs-target="#infGeneral"
            type="button" role="tab" aria-controls="infGeneral" aria-selected="true">
            <h5><strong>Inf.General</strong></h5>
          </button>
        </li>
        <li class="nav-item">
          <!-- <a class="nav-link" href="#docRelacionados" data-toggle="tab">
            <h3><strong>Doc.Relacionados</strong></h3>
          </a> -->
          <button class="nav-link " id="docRelacionados-tab" data-bs-toggle="tab" data-bs-target="#docRelacionados"
            type="button" role="tab" aria-controls="docRelacionados" aria-selected="false">
            <h5><strong>Doc.Relacionados</strong></h5>
          </button>
        </li>
        <li class="nav-item">
          <!-- <a class="nav-link" href="#pagos" data-toggle="tab">
            <h3><strong>Pagos</strong></h3>
          </a> -->
          <button class="nav-link " id="pagos-tab" data-bs-toggle="tab" data-bs-target="#pagos" type="button" role="tab"
            aria-controls="pagos" aria-selected="false">
            <h5><strong>Pagos</strong></h5>
          </button>
        </li>
      </ul>
    </div>

    <div class="tab-content">

    <div class="tab-pane fade show active" id="infGeneral" role="tabpanel" aria-labelledby="infGeneral-tab">
      <!-- <div role="tabpanel" class="active tab-pane" id="infGeneral"> -->
        <app-lfsa-card [innTemplate]="OpcionGeneral" [titulo]="'Inf.General'" [efecto]="false"
          [colapseName]="'tabGeneral'" [banderaColapse]='true'></app-lfsa-card>
        <ng-template #OpcionGeneral>
          <div class="row">
            <div class="col-12 col-sm-12 col-md-12 col-lg-3">
              <div id="tarjeta" class="card border-success" *ngIf="objSelected?.documentoSelect !== null">
                <br>
                <div class="col-12">
                  <button (click)="callModalOption($event)" class="btn btn-success btn-block">Validar</button>
                </div>
                <hr>
                <div class="col-12" *ngIf="objSelected?.documentoSelect?.lstSustentoDoc">
                  <b>Usuario</b>: {{ objSelected?.documentoSelect?.lstSustentoDoc[0]?.susDocRevUser }}
                </div>
                <div class="col-12" *ngIf="objSelected?.documentoSelect?.lstSustentoDoc">
                  <b>Fecha</b>: {{ objSelected?.documentoSelect?.lstSustentoDoc[0]?.susDocRevDate }}
                </div>
                <div class="col-12" *ngIf="objSelected?.documentoSelect?.lstSustentoDoc">
                  <b>Estado</b>: {{ objSelected?.documentoSelect?.lstSustentoDoc[0]?.susDocRevStatDesc }}
                </div>
                <hr>
                <div class="col-12">
                  <b>Factura</b>: {{ objSelected?.documentoSelect?.numDocumento }}
                </div>
                <div class="col-12">
                  <b>Cliente</b>: {{ objSelected?.documentoSelect?.cliente?.idCliente }}
                  {{ objSelected?.documentoSelect?.cliente?.nombreCliente1 }}
                </div>
                <div class="col-12">
                  <b>Ruc</b>: {{ objSelected?.documentoSelect?.cliente?.rucCliente }}
                </div>
                <div class="col-12">
                  <b>Fecha</b>: {{ objSelected?.documentoSelect?.fechaDocumento }}
                </div>
                <div class="col-12">
                  <b>Dirección</b>: {{ objSelected?.documentoSelect?.cliente?.direccionCliente }}
                </div>
                <div class="col-12">
                  <b>Correo</b>: Pendiente
                </div>
                <div class="col-12">
                  <b>Asiento</b>: {{ objSelected?.documentoSelect?.numAsiento }}
                </div>
                <div class="col-12">
                  <b>Subtotal</b>: {{ objSelected?.documentoSelect?.subTotalDoc }}
                </div>
                <div class="col-12">
                  <b>Base0</b>: {{ objSelected?.documentoSelect?.base0Doc }}
                </div>
                <div class="col-12">
                  <b>Base Iva</b>: {{ objSelected?.documentoSelect?.baseImpDoc }}
                </div>
                <div class="col-12">
                  <b>Valor Iva</b>: {{ objSelected?.documentoSelect?.valorIvaDoc }}
                </div>
                <div class="col-12">
                  <b>Total</b>: {{ objSelected?.documentoSelect?.totalDoc }}
                </div>
              </div>
              <br>
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-9">
              <div class="card border-success" *ngIf="objSelected != null">
                <object [data]="pdfB64" width="100%" height="450" type='application/pdf'></object>
              </div>
              <br>
            </div>
          </div>
        </ng-template>
        <br>
      </div>

      <div class="tab-pane fade" id="docRelacionados" role="tabpanel" aria-labelledby="docRelacionados-tab">
      <!-- <div role="tabpanel" class="tab-pane fade" id="docRelacionados"> -->
        <app-lfsa-card [innTemplate]="OpcionRelacionados" [titulo]="'Doc. Relacionados'" [efecto]="false"
          [colapseName]="'tabRelacionados'" [banderaColapse]='true'></app-lfsa-card>
        <ng-template #OpcionRelacionados>
          <app-lfsa-loading-v2 *ngIf="loader"></app-lfsa-loading-v2>
          <div *ngIf="!loader">
            <div class="row">
              <div class="col-12 col-sm-12 col-md-6 col-lg-3">
                <div class="card border-success" *ngIf="objSelected != null">

                  <div>
                    <ul>
                      <!-- <li *ngFor="let item of dataTreeAfect"> -->
                      <li *ngFor="let item of dataTree">
                        <span *ngIf="item.open" class="fa"
                          (click)="action(item)">&#xf114;&nbsp;<b>{{item.name}}</b></span>
                        <span *ngIf="!item.open" class="fa"
                          (click)="action(item)">&#xf115;&nbsp;<b>{{item.name}}</b></span>
                        <br>
                        <ul *ngIf="!item.open">
                          <li id="item" *ngFor="let item of item.children" ng-show="item.active">
                            <span class="fa"
                              (click)="callActionDocumntoAfect(item)">&nbsp;&#xf016;&nbsp;{{item.name}}</span>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </div>

                </div>
                <br>
              </div>
              <div class="col-12 col-sm-12 col-md-6 col-lg-3">
                <div class="card border-success" *ngIf="objTreeAfect != null">
                  <div class="col-12">
                    <b>N°Documento</b>:{{ objTreeAfect.documentoAfectado.documentoPK.tdoc +" - "+
                    objTreeAfect.documentoAfectado.documentoPK.docn + " - "+
                    objTreeAfect.documentoAfectado.documentoPK.lino }}
                  </div>
                  <div class="col-12">
                    <b>Fecha Documento</b>: {{ objTreeAfect.documentoAfectado.fechaDocumento }}
                  </div>
                  <div class="col-12">
                    <b>Valor</b>: {{ objTreeAfect.documentoAfectado.importe }}
                  </div>
                </div>
                <br>
              </div>
              <div class="col-12 col-sm-12 col-md-12 col-lg-6">
                <div class="card border-success" *ngIf="objSelected != null">
                  <object [data]="pdfB64" width="100%" height="450" type='application/pdf'></object>
                </div>
                <br>
              </div>
            </div>
          </div>
        </ng-template>
        <br>
      </div>

      <div class="tab-pane fade" id="pagos" role="tabpanel" aria-labelledby="pagos-tab">
      <!-- <div role="tabpanel" class="tab-pane fade" id="pagos"> -->
        <app-lfsa-card [innTemplate]="OpcionPagos" [titulo]="'Pagos'" [efecto]="false" [colapseName]="'tabPagos'"
          [banderaColapse]='true'></app-lfsa-card>
        <ng-template #OpcionPagos>
          <app-lfsa-loading-v2 *ngIf="loader"></app-lfsa-loading-v2>
          <div *ngIf="!loader">
            <div class="row">

              <div class="col-12 col-sm-12 col-md-6 col-lg-3">
                <div class="card border-success" *ngIf="objSelected != null">
                  <div>
                    <ul>
                      <li *ngFor="let item of dataTree">
                        <span *ngIf="item.open" class="fa"
                          (click)="action(item)">&#xf114;&nbsp;<b>{{item.name}}</b></span>
                        <span *ngIf="!item.open" class="fa"
                          (click)="action(item)">&#xf115;&nbsp;<b>{{item.name}}</b></span>
                        <br>
                        <ul *ngIf="!item.open">
                          <li id="item" *ngFor="let item of item.children">
                            <span class="fa"
                              (click)="callActionDocumento(item)">&nbsp;&#xf016;&nbsp;{{item.name}}</span>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </div>
                <br>
              </div>

              <div class="col-12 col-sm-12 col-md-6 col-lg-3">
                <div class="card border-success" *ngIf="objTreeNode != null">
                  <br>
                  <div class="col-12">
                    <button (click)="callModalOption($event)" class="btn btn-success btn-block">Validar</button>
                  </div>
                  <br>
                  <div class="col-12">
                    <button (click)="callModalSustento($event)" class="btn btn-success btn-block">Sustento Foto</button>
                  </div>
                  <hr>
                  <div class="col-12">
                    <b>Status</b>: {{ objTreeNode.documentoSelect.sustentoDoc.susDocRevStatDesc }}
                  </div>
                  <div class="col-12">
                    <b>Usuario</b>: {{ objTreeNode.documentoSelect.sustentoDoc.susDocRevUser }}
                  </div>
                  <div class="col-12">
                    <b>Fecha</b>: {{ objTreeNode.documentoSelect.sustentoDoc.susDocRevDate }}
                  </div>
                  <hr>
                  <div class="col-12">
                    <b>Cambio Imagen</b>: {{ objTreeNode.documentoSelect.sustentoDoc.modSusImgUser }}
                  </div>
                  <div class="col-12">
                    <b>Fecha</b>: {{ objTreeNode.documentoSelect.sustentoDoc.modSusImgDate }}
                  </div>
                  <hr>
                  <div class="col-12">
                    <b>N°Documento</b>:
                    {{ objTreeNode.documentoSelect.documentoPK.tdoc +" - "+objTreeNode.documentoSelect.documentoPK.docn
                    + " - "+ objTreeNode.documentoSelect.documentoPK.lino }}
                  </div>
                  <div class="col-12">
                    <b>Fecha Documento</b>: {{ objTreeNode.documentoSelect.fechaDocumento }}
                  </div>
                  <div class="col-12">
                    <b>Fecha Registro</b>: {{ objTreeNode.documentoSelect.fechaRegistro }}
                  </div>
                  <div class="col-12">
                    <b>Valor</b>: {{ objTreeNode.documentoSelect.importe }}
                  </div>
                  <div class="col-12">
                    <b>Asiento Contable</b>: {{ objTreeNode.documentoSelect.numAsiento }}
                  </div>
                  <div class="col-12">
                    <b>#Finalización</b>: {{ objTreeNode.documentoSelect.numFinalizacion }}
                  </div>
                  <div class="col-12">
                    <b>Periodo Contable</b>: {{ objTreeNode.documentoSelect.periodo }}
                  </div>
                  <div class="col-12">
                    <b>Doc.Aplica</b>:
                    {{ objTreeNode.documentoSelect.documentoPK.ttyp +" - "+ objTreeNode.documentoSelect.documentoPK.ninv
                    + " - " + objTreeNode.documentoSelect.documentoPK.line }}
                  </div>
                </div>
                <br>
              </div>

              <div class="col-12 col-sm-12 col-md-12 col-lg-6">
                <div class="card border-success" *ngIf="objSelected != null">
                  
                  <ul class="nav nav-tabs" id="myTab" role="tablist">
                    <div *ngFor="let item of objSelected.documentoSelect.listImagenSustentoPago; let i = index">
                      <li class="nav-item" role="presentation">
                        <button class="nav-link" (click)="selectTabPagos(item)" id="home-tab{{i}}" data-bs-toggle="tab" [attr.data-bs-target]="'#home'+i" type="button" role="tab" aria-controls="home" aria-selected="true">Doc{{i+1}}</button>
                      </li>
                    </div>
                  </ul>
                  
                  <!-- Tab panes -->
                  <div class="tab-content" *ngFor="let item of objSelected.documentoSelect.listImagenSustentoPago; let i = index">
                    
                      <div class="tab-pane" id="home{{i}}" role="tabpanel" [attr.aria-labelledby]="'home-tab'+i">
                        
                        <div class="card-body">
                          <div *ngIf=" item.imagStr !== null ">
                            <object
                            [data]="sanitizer.bypassSecurityTrustResourceUrl('data:application/pdf;base64,' + item.imagStr)"
                            width="100%" height="450" type='application/pdf'>
                            </object>
                          </div>
                          <div *ngIf="item.imagStr === undefined || item.imagStr === null">
                            <div class="alert alert-danger animated fadeInRight" role="alert">
                            No existe sustento para este documento.
                            </div>
                          </div>
                          </div>
                      </div>
                  </div>
                  <br>


                </div>
                
              </div>
            </div>
          </div>
        </ng-template>
        <br>
      </div>

    </div>
  </div>

</ng-template>


<!-- MODAL OPCIONES -->
<app-lfsa-modal #abrirModalOpciones [innTemplate]="enviarModal" [titulo]="'Status Sustento'"
  [idButton]="'abrirModalOpciones'" [idOpen]="'ModalOpciones'" [idClose]="'cerrarModalOpciones'"></app-lfsa-modal>
<ng-template #enviarModal>
  <div [formGroup]="formOptions" novalidate class="form-group">
    <div class="row">
      <div class="form-group col-md-12">
        <app-lfsa-combo-box [opcion]="'valor'" [idOpcion]="'clave'" [comboBox]="cmbOpciones"
          formControlName="statusSustento" [control]="formOptions.get('statusSustento')" [label]="'Status Sustento'"
          [id]="'statusSustento'">
        </app-lfsa-combo-box>
      </div>
      <hr>
      <div class="row col-12">
        <div class="col-md-12">
          <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
          <div *ngIf="!loading">
            <button (click)="editStatusSustento()" [disabled]="formOptions.invalid"
              class="btn btn-success btn-block">Guardar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<!-- MODAL O -->
<app-lfsa-modal [innTemplate]="enviarModalSustento" [titulo]="'Status Sustento'" [idButton]="'abrirModalSustento'"
  [idOpen]="'ModalSustentos'" [idClose]="'cerrarModalSustentos'"></app-lfsa-modal>
<ng-template #enviarModalSustento>
  <div [formGroup]="formOptions" novalidate class="form-group">
    <div class="row">
      <div class="form-group col-md-12">

        <label for="csvInput" class="letrasDanger">Sustentos*</label>
        <input type="file" class="form-control-file" id="suatentoInput" (change)="onFileSelect($event)" #fileInput />
      </div>
      <hr>
      <div class="row col-12">
        <div class="col-md-12">
          <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
          <div *ngIf="!loading">
            <button (click)="uploadSustento()" [disabled]="formSustento.invalid"
              class="btn btn-success btn-block">Guardar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
